import $ from 'jquery';

var menu = function() {

  const body = $('body');
  const clock = $('.clock-menu');
  const button = $('.hamburger');
  const menu = $('.menu-popover');

  function boneMenu() {
    if(body.hasClass('menu-open'))
    {
      //Close it
      $('.header').removeClass('nav-down');
      menu.removeClass('active');
      body.removeClass('menu-open');
      clock.removeClass('active');
      button.removeClass('active');
    }
    else
    {
      //Show it
      $('.header').addClass('nav-down');
      menu.addClass('active');
      body.addClass('menu-open');
      clock.addClass('active');
      button.addClass('active');
    }

    //------------------------------
    //Helper funciton
    //------------------------------
    $.wait = function (ms) {
        var defer = $.Deferred();
        setTimeout(function () { defer.resolve(); }, ms);
        return defer;
    };
  }

  $('a.hamburger-trigger').click(function (e) {
      e.preventDefault();
      boneMenu();
  });

   function footerEmail() {

      $('.newsletter-sub').on('click', function() {
         if ($('.email-sub input:focus')) {
            $('#gform_wrapper_3 .gform_footer').addClass('active');
         }
      });

      $('.email-sub input').on('blur', function() {

         if ($(this).val().length <= 0) {
            $('#gform_wrapper_3 .gform_footer').removeClass('active');
         }
      });
   }

   footerEmail();

}

module.exports = menu;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/menu.js